module.exports = {"breakpoints":{"sm":"480","md":"750","lg":"1000","xl":"1200"},"rules":{"webkit":"(-webkit-min-device-pixel-ratio: 0)","retina":"(-webkit-min-device-pixel-ratio: 2), (min--moz-device-pixel-ratio: 2), (-o-min-device-pixel-ratio: 2/1), (min-device-pixel-ratio: 2), (min-resolution: 192dpi), (min-resolution: 2dppx)"}}


//////////////////
// WEBPACK FOOTER
// ./src/css/media-queries.json
// module id = 14
// module chunks = 1